import { render } from "./PagesListEntry.vue?vue&type=template&id=3380026e&scoped=true"
import script from "./PagesListEntry.vue?vue&type=script&lang=js"
export * from "./PagesListEntry.vue?vue&type=script&lang=js"

import "./PagesListEntry.vue?vue&type=style&index=0&id=3380026e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3380026e"]])

export default __exports__